import { render, staticRenderFns } from "./Wue.vue?vue&type=template&id=0479adb8&scoped=true&"
import script from "./Wue.vue?vue&type=script&lang=js&"
export * from "./Wue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0479adb8",
  null
  
)

export default component.exports